import { ssoGetConfig,login } from '@/api/login';
import store from '@/store';

export const logout =(config) =>{
    let url =config.base_url+"oauth2"+config.realm_path+"/connect/endSession?id_token_hint="+config.id_token+"&post_logout_redirect_uri="+config.logout_redirect_uri;
    window.location.href = url;
};

export const ssoLogin = async () =>{
    let params = GetRequest();
    if(params && params.access_token){
        await login({
            accessToken:params.access_token
        });
        localStorage.setItem('accessToken',params.access_token);
    }else{
        if(!localStorage.getItem('accessToken')){
            const config = await ssoGetConfig();
            store.commit('sso/setSSOconfig',config);
            let url = `${config.base_url}oauth2${config.realm_path}/authorize?client_id=${config.client_id}&state=${config.state}&scope=${config.scope}&redirect_uri=${config.redirect_uri}&response_type=${config.response_type}&nonce=${config.nonce}`;
            window.location.href = url;
            return false
        };
        
    }
};

function GetRequest() {
    const url = location.href; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1 || url.indexOf("#") != -1) {
       let str = url.split('/#/')[1];
       let strs = str.split("&");
       for(let i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
       }
    }
    return theRequest;
 }
 function getCookie(name){
    let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}